<section class="sale-section">
  <div class="header">
    <h2>Ưu Đãi Vợt Cầu Lông</h2>
    <p>Khám phá các mẫu đang sale và vợt cũ giá tốt.</p>
  </div>

  <div class="grid">
    <div class="card" *ngFor="let item of rackets">
      <div class="image-wrap">
        <span class="badge">{{ item.badge }}</span>
        <img [src]="item.image" [alt]="item.name">
      </div>

      <div class="content">
        <small>{{ item.condition }}</small>
        <h3>{{ item.name }}</h3>

        <div class="price-row">
          <span class="old">{{ item.originalPrice | number }}đ</span>
          <span class="new">{{ item.salePrice | number }}đ</span>
        </div>

        <button>Mua ngay</button>
      </div>
    </div>
  </div>
</section>